export default {"src":"/_next/static/media/facekbook-icon.e449038f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};